<template>
	<div class="main-service">
		<navigations :path="path"></navigations>

		<img class="service-img" src="../assets/back-1.png" alt="" />

		<div class="container-service">
			<div class="service-richtext">
				<span class="service-richtext-title">时购圈平台用户服务协议</span>
				<span class="service-richtext-content">
					<div>
						<p><span style="font-weight: bold; color: #007bff">时购圈用户协议</span></p>
						<p><span>欢迎您注册时购圈账号并使用时购圈的服务！</span></p>
						<p>
							<span>本《时购圈用户协议》（以下简称“</span>
							<span style="font-weight: bold; color: #007bff">本协议”</span>
							<span>）是您与时购圈之间就注册时购圈用户账号及使用时购圈的各项服务等相关事宜所订立的协议。</span>
							<span style="font-weight: bold; color: #007bff">
								为使用时购圈的服务，您应当仔细阅读并遵守本协议下的全部内容，特别是涉及免除或者责任限制的条款，该类条款可能以黑体加粗或加下划线的形式提示您重点注意。
							</span>
							<span>
								除非您已阅读并接受本协议所有条款，否则您将不能注册时购圈账号或使用时购圈的服务，如您不同意本条款的任意内容，请勿注册或使用时购圈的服务，并应立即停止注册程序。如您对本协议的内容（特别是涉及免除或者责任限制的条款）有任何疑义，可随时按照本协议中列明的联系方式与我们联系，我们将根据您的要求为您进一步解释和说明相关内容。
							</span>
							<span style="font-weight: bold; color: #007bff">
								如您勾选“我同意”并通过注册程序或其他任何方式使用或接受时购圈的任何服务，即视为您已阅读并同意本协议，并自愿接受本协议及时购圈相关协议和管理制度的所有内容的约束。请您在决定注册或使用服务前再次确认您已知悉并完全理解本协议的所有内容。
							</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">如果您未满18周岁，请务必在家长和其他法定监护人的陪同下阅读本协议，并在进行注册、下单、支付等任何行为或使用时购圈的其他任何服务前，应事先征得您的家长和其他法定监护人的同意。</span>
						</p>
						<p>
							<span>本协议所述“服务”既包括您使用时购圈用户账号接受时购圈平台相关商家、个人所提供的服务，亦包括在某些特定的业务类别下您使用时购圈用户账号向其他商家、个人或其他主体提供服务的情形。无论“服务”属于上述何种情形，本《时购圈用户协议》都将予以适用。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">一、协议的主体与范围</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【签约主体】</span>
							<span> 视您所使用的具体服务而定，“时购圈”是指时购圈旗下运营或提供您所使用的相关具体服务的相关主体的统称，您可在相关服务的具体服务条款或说明文件中查看上述主体的名称和信息。 “用户”是指使用时购圈相关服务的使用人，在本协议中更多称呼为“您”。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【协议内容】</span>
							<span>本协议内容同时包括：</span>
						</p>
						<p>
							<span>（1）&nbsp;本《时购圈用户协议》文本；</span>
						</p>
						<p>
							<span>（2）《时购圈隐私政策》：时购圈非常重视您的个人信息和隐私的保护，将按照《时购圈隐私政策》中所公布的政策在具体服务中进行隐私及个人信息的收集、存储、使用、披露等活动。您在注册时购圈账号前，应仔细阅读《时购圈隐私政策》；</span>
						</p>
						<p>
							<span>（3）具体服务的服务条款：您的时购圈平台账号一经注册，即可凭该账号按规定享受时购圈平台上的各项丰富的服务。为更好地向您提供各项服务，时购圈平台针对具体的服务制定了专门的服务条款，供服务各方遵守。您可在【相关具体服务的网站、页面或应用程序】中查阅此类专门服务条款。您在使用具体服务前，应仔细阅读该服务所适用的服务条款，您注册时购圈账号并利用时购圈账号使用具体服务即表示您已同时接受该等服务条款，并将受该等服务条款的约束；</span>
						</p>
						<p>
							<span>（4）第三方服务相关的用户授权协议：为方便您在使用时购圈平台服务的同时，根据您自身需要，通过时购圈平台进行跳转等方式，包括但不限于登录、支付、地图、消息推送等第三方服务，自愿选择接受独立第三方服务商及部分关联第三方服务商所提供的服务，您将在使用该等第三方服务前对相应的用户授权协议予以同意确认，以作为您和时购圈平台之间就该等第三方服务的使用所涉及的相关事项的权利义务依据。</span>
						</p>
						<p>
							<span>上述各项内容之间如存在不一致之处，以时间上最新发布的内容为准，发布时间相同的，以本款【协议内容】中所包含的组成部分的序号倒序排列为准。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【特定业务规则】</span>
							<span>平台就特定业务（包括但不限于会员卡、优惠券、拼玩活动、城市合伙人、赛事活动、扫码点餐等）制定了专项管理规范或公约。您注册、使用相应特定服务即视为同意接受《时购圈隐私政策》中关于个人信息处理（包括第三方共享、推送等）的约定等专项规则的约束，该等专项规则与本协议共同构成对双方有约束力的合约。如专项规则与本协议存在不一致，应以该专项规则的规定为准。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【赛事与扫码点餐专项规则】</span>
						</p>
						<p>
							<span>平台就赛事活动、扫码点餐等特定业务制定了专项管理规范。您在使用相应服务时，应另行阅读并同意相应的专项规则：</span>
						</p>
						<p>
							<span>（1）赛事服务：您作为参赛用户报名赛事时，应另行勾选同意《时购圈平台赛事报名用户公约》；您作为主办方发布赛事时，应另行勾选同意《时购圈平台赛事主办方使用公约》。该等公约构成本协议不可分割的组成部分，自您勾选同意时对您生效。若您未勾选同意相应公约，平台有权拒绝提供赛事报名或赛事发布服务。就赛事服务，赛事专项公约有约定的，优先适用赛事专项公约；赛事专项公约未约定的，适用本协议。平台仅提供赛事技术支持服务，不是赛事主办方或组织方。赛事的实际组织、安全、保险、奖项发放等由主办方负责，具体责任划分以相应赛事专项公约约定为准。</span>
						</p>
						<p>
							<span>（2）扫码点餐服务：您首次使用扫码点餐服务时，平台或合作商户将在身份确认环节以显著方式向您展示个人信息处理规则，并征得您的主动勾选同意后，方进行身份核验。您拒绝同意的，仍可通过纸质菜单或人工点餐完成消费。平台仅提供扫码点餐的技术支持服务，不参与餐饮服务的实际提供。餐品质量、价格、食品安全、就餐服务等由合作商户负责。扫码点餐的个人信息处理规则构成本协议不可分割的组成部分。就扫码点餐服务，专项规则有约定的优先适用；专项规则未约定的，适用本协议及《时购圈隐私政策》。</span>
						</p>
						<p>
							<span>上述专项规则与本协议约定不一致的，以专项规则为准；专项规则未约定的，适用本协议及《时购圈隐私政策》。平台可依法修订上述专项规则，并通过页面公告、弹窗等合理方式通知您。修订后您继续使用相应服务的，视为您接受修订内容；涉及个人信息处理规则重大变更的，需重新取得您的同意。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【协议遵守】</span>
							<span>您理解并同意：</span>
						</p>
						<p>
							<span>（1）上述【协议内容】中所述的协议、政策、条款与规则构成本协议不可分割的组成部分，共同适用于您所使用的时购圈平台服务。</span>
						</p>
						<p>
							<span>（2）根据国家法律法规变化、运营需要或为提升服务质量的目的，时购圈将在必要的时候对上述各项协议、条款与规则不时地进行修改更新，并通过在网页或移动客户端上发出公告、系统等合理、醒目的方式向您进行提前通知，上述修改更新内容将在相关更新说明中指定的日期开始实施，通常情况下不短于发布之日后八个自然日。</span>
						</p>
						<p>
							<span>（3）&nbsp;您应当及时查阅并了解相关更新修改内容，如您不同意相关更新修改内容，可停止使用相关更新修改内容所涉及的服务，此情形下，变更事项对您不产生效力；如您在上述更新修改内容实施后继续使用所涉及的服务，将视为您已同意各项更新修改内容。</span>
						</p>
						<p>
							<span>（4）如您作为商家或其他服务提供方，与时购圈或其授权的代理方（如《时购圈平台商家入驻合作协议》中的“甲方”）另行签署了《时购圈平台商家入驻合作协议》或其他专门的商家服务协议（以下统称“专门协议”），就您通过时购圈平台向其他用户提供商品或服务达成合作。</span>
						</p>
						<p>
							<span>在此情况下，本协议与您签署的专门协议将共同构成对双方有约束力的完整合约。 本协议作为平台基础通用规则，适用于您账号的所有使用行为；专门协议则针对您的商家身份，就合作内容、费用、结算等作出具体约定。</span>
						</p>
						<p>
							<span>即专门协议中引用的“平台服务协议”即指本协议。若本协议的规定与您签署的专门协议的规定发生冲突或不一致，应优先适用专门协议中的规定。专门协议未约定的事项，仍适用本协议。</span>
						</p>
						<p>
							<span>（5）平台所有产品与服务，均须遵守平台针对特定业务（如会员卡、优惠券、拼玩活动等）制定的未成年人保护特别规定。推送内容不得包含不适宜未成年人的信息用户注册、使用特定服务即视为同意遵守该等规定。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【适用平台】</span>
							<span>本协议适用于移动客户端（包括安卓及已有或未来将新增的任何其他移动客户端）等各类平台或媒介中时购圈所提供的各项服务。您知悉并理解，为享受上述相关服务，您必须自行提供相关上网设备（如：手机或其他设备）并自行负担相关网络使用和商品服务支付所产生的有关费用。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">二 、账号的注册</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【注册资料】</span>
							<span>您应遵循诚实信用、合法善意的原则，向时购圈提交相关注册资料，相关注册资料应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公序良俗、信息真实等原则，不应提交任何违法或不良信息，相关资料如有变动，您应及时更新。如果因您所提供的注册资料不合法、不真实、不准确或未及时更新，从而导致相关法律责任或不利后果的，您将承担相应的法律责任及不利后果。</span>
						</p>
						<p>
							<span>您已知悉，在时购圈账号注册过程中，因安全性、内部管理等原因，部分初始注册资料可能将无法再次更改。因此，您应谨慎核查此部分注册资料，确保正确填写。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【民事行为能力】</span>
							<span>您知悉并承诺，您具有完全民事权利能力和行为能力或虽不具有完全民事权利能力和行为能力但已经过您的家长和其他法定监护人同意并由您的家长和其他法定监护人代理注册及使用时购圈的各项服务。若您不具备前述相适应的民事行为能力即进行账号注册的，则您及您的家长和其他法定监护人应依照法律规定承担因此而导致的一切后果。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【真实身份】</span>
							<span>因国家法律法规、监管要求，需要您在注册或使用该等服务的特定环节中填写真实的身份信息，并需通过相关验证流程后方可使用服务，如您填写的身份信息不完整、不真实或未通过验证，将导致您无法使用该服务、损害自身、他人利益或造成其他不利后果，该等后果将由您予以承担。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【注册信息保护】</span>
							<span>时购圈将对您所提交的注册信息予以保护，不会将其披露给任何非关联的第三方，除非：</span>
						</p>
						<p>
							<span>（1）相关法律法规或国家机关要求；</span>
						</p>
						<p>
							<span>（2）时购圈发生相关合并、分立、收购或资产转移；</span>
						</p>
						<p>
							<span>（3）为提供相关服务所必须的。</span>
						</p>
						<p>
							<span>对于您所提交的注册信息中涉及个人信息的内容，时购圈将严格按照《时购圈隐私政策》的规定进行收集、处理和使用。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【账号数量】</span>
							<span>除因历史原因、业务整合等时购圈所认可的特殊情况外，时购圈原则上只允许您使用一个时购圈用户账号。如有证据证明或时购圈有理由相信您存在不当注册或不当使用多个时购圈账号的情形，时购圈可将相关账号信息进行合并或采取其他合理措施，如因您不当注册或不当使用给时购圈及相关方造成损失的，您还应承担相应的赔偿责任。此外，出于相关业务需要，时购圈也可对同一用户的多个账号或相关信息进行合并，如该等合并将对您的权益产生实质影响，时购圈将在进行上述合并前事先征得您的同意。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">三、&nbsp;账号的使用</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【账号注册与登录】</span>
						</p>
						<p>
							<span>您可选择以下方式登录或注册账号：</span>
						</p>
						<p>
							<span>（1）微信登录：需授权我们从微信平台获取您已公开的基本信息（如昵称、头像），该功能由腾讯公司提供，您应遵守其相关协议。</span>
						</p>
						<p>
							<span>（2）本机一键登录：需授权读取本机号码及运营商信息以完成认证，我们仅将信息用于身份验证，不会存储SIM卡数据。</span>
						</p>
						<p>
							<span>（3）微信小程序授权登录：</span>
						</p>
						<p>
							<span>您可以通过微信小程序授权的方式快速登录时购圈平台，包括授权获取您微信账号的基本信息和绑定的手机号码。您理解并同意，该授权过程由腾讯公司提供技术支持，您应遵守《微信小程序服务协议》及相关规范。关于个人信息收集和使用的具体规则，请详见《时购圈隐私政策》。</span>
						</p>
						<p>
							<span>您理解并同意，拒绝提供上述授权可能导致部分功能无法使用，但不影响您通过其他方式（如手机号验证码）注册或登录。时购圈可根据相关法律法规、监管要求、用户体验、风险控制等因素对登录方式予以适时调整或增减，或在具体业务门类的用户服务条款等规定中予以进一步细化或调整。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【账号使用】</span>
							<span>您应对您账号项下的所有行为（包括但不限于在线签署任何协议，浏览、购买、支付、点评、上传、发布、输入任何内容）所产生的一切后果负责，通过您的账号所发生的上述各项行为将视为您本人的真实意思表示。</span>
						</p>
						<p>
							<span>时购圈提示您，您通过自身账号在接受时购圈的各项服务中所上传、发送的任何内容都应具有合法来源，如相关内容涉及任何第三方的合法权益，应事先获得相应的许可。如时购圈收到涉及您的相关举报或投诉，时购圈可采取相关法律法规所要求或允许的方式，向相关争议方、相关部门提供包括账号在内的必要的信息，以便解决纠纷争议，保护正当权利人的合法权益。</span>
						</p>
						<p>
							<span>您通过时购圈旗下注册账号登录和使用时购圈或第三方提供的各种软件和服务时，请您注意，您的账号头像、昵称等个人信息还可能通过时购圈的服务或第三方提供的服务向您本人或其他用户展示。</span>
						</p>
						<p>
							<span>时购圈提示您，为提高您发布的内容的曝光量及发布效率，您同意您通过时购圈旗下注册账号发布的全部内容均授权时购圈以您的账号自动同步至时购圈运营的其他软件及网站，您账号的头像、昵称等公开信息可能会一并同步。您通过自身账号在接受时购圈的各项服务中所上传、发送的任何内容都应具有合法来源，如相关内容涉及任何第三方的合法权益，应事先获得相应的许可。如时购圈收到涉及您的相关举报或投诉，时购圈可采取相关法律法规所要求或允许的方式，向相关争议方、相关部门提供包括账号在内的必要的信息，以便解决纠纷争议，保护正当权利人的合法权益。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【消息推送】</span>
						</p>
						<p>
							<span>您知悉并同意，为向您提供及时的服务通知、优惠信息或活动提醒，时购圈可能通过自身或第三方推送服务供应商（如每日互动股份有限公司）向您发送推送消息。您可以通过设备系统设置管理消息推送权限，但关闭推送可能影响部分服务体验。关于推送服务中个人信息的处理方式，请详见《时购圈隐私政策》。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【账号借用】</span>
							<span>为保证相关账号安全，未经时购圈的书面同意，您不应将时购圈平台上所注册的账号借给他人使用，否则您应当承担由此产生的全部责任，时购圈平台保留拒绝提供相应服务、冻结或收回注册账号或终止本协议的权利，并可要求您对时购圈所承受的损失予以赔偿。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【安全义务】</span>
							<span>如您发现账号存在安全问题，请您立即联系时购圈予以调查处理，否则时购圈对潜在损失的产生或扩大不承担任何责任。</span>
						</p>
						<p>
							<span>时购圈特别提示您，您应该妥善保管您的账号和密码，当您使用完毕时购圈的服务后，您应安全退出。此外，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意时购圈有关防范诈骗犯罪的提示。您知悉并同意，如您在账号信息的保管上、相关上网设备的网络安全维护上存在任何过失导致账号丢失、泄露，您应对此所产生的任何后果负责，时购圈对此不负任何责任，如时购圈因此产生相关支出，时购圈将有权向您予以追偿。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【限制冻结】</span>
							<span>您知悉并同意，在符合法律法规的规定，或经国家机关要求的前提下，时购圈有权对您的注册账号进行限制或冻结，在该等情况下，您可能无法继续登陆或使用您的注册账号。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【账号绑定的手机号】</span>
						</p>
						<p>
							<span>您理解并同意，您注册时提供的手机号码是您时购圈账号的核心安全凭证，用于登录、身份验证、找回密码、接收重要通知等。</span>
						</p>
						<p>
							<span>手机号更换： 如您需要更换与账号绑定的手机号，您必须通过平台提供的“账号与安全”等官方流程进行操作。通常情况下，您需要验证原手机号（如接收验证码）并进行身份核实。您有义务确保新手机号为您本人合法持有并使用。</span>
						</p>
						<p>
							<span>风险自担： 您知悉并同意，因您未能及时更新或准确提供手机号信息（包括但不限于手机号停用、注销、转让给他人而未及时换绑），或因运营商“二次放号”等非平台可控制的原因，导致您无法接收平台通知、账号被盗用、或您的个人信息泄露等任何损失，应由您自行承担。</span>
						</p>
						<p>
							<span>及时通知： 一旦发生手机丢失、SIM卡挂失或手机号变更的情况，您应立即按照平台要求的程序更换绑定手机号。因您怠于通知而导致的任何损失，平台不承担法律责任。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">四、用户行为规范与责任承担</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【用户义务】</span>
							<span>您知悉并承诺，在使用时购圈所提供的服务的过程中，您应遵守相关法律法规，不应从事如下违反法律法规的规定，影响正常服务提供或损害他人合法利益的行为：</span>
						</p>
						<p>
							<span>（1） 不应利用时购圈平台或相关服务危害国家安全、破坏政治稳定、泄露国家秘密，不侵犯国家、社会、集体利益和第三方的合法权益，不从事违法犯罪活动，不设立用于实施诈骗，传授犯罪方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，不利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息；</span>
						</p>
						<p>
							<span>（2）不应制作、发布、复制、查阅和传播、存储、链接下列信息：反对宪法所确定的基本原则的；危害国家安全，泄露国家秘密，颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；捏造、散布谣言，侵犯他人权利，扰乱经济、社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；宣扬恐怖主义、极端主义的；违背当地风俗习惯的；含有法律、行政法规禁止的其他内容的；</span>
						</p>
						<p>
							<span>（3）&nbsp;不应从事下列危害计算机信息网络安全的活动：对网络服务及相关软硬件设施进行破解、破坏、删除、修改或者增加的；对计算机信息网络中存储或者传输的数据和应用程序进行删除、修改或者增加的；使用软件或硬件等方式窃取他人口令、非法入侵他人计算机系统；故意制作、传播计算机病毒等破坏性程序的；其他危害计算机信息网络安全的活动；</span>
						</p>
						<p>
							<span>（4）不应擅自复制和使用网络上未公开和未授权的文件。除相关著作权人明示同意，不应在网络中擅自破解、传播、下载或复制第三人享有著作权的软件或进行其他任何侵害他人知识产权的活动；</span>
						</p>
						<p>
							<span>（5）不应私自传播广告信息或以“刷单”等不正当方式帮助他人提升评价或利用评价权利对其他用户、商户实施威胁、敲诈勒索；</span>
						</p>
						<p>
							<span>（6）不应因对时购圈相关服务的使用行为导致时购圈卷入政治和公共事件；</span>
						</p>
						<p>
							<span>（7）不应通过侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册、用机器注册时购圈平台账户、用机器模拟客户端等手段进行交易或参加时购圈或其所授权的第三方发布的任何活动；</span>
						</p>
						<p>
							<span>（8）未经时购圈事先书面许可，不应自行或授权、协助任何第三方非法抓取时购圈所展示的任何内容（“非法抓取”是指采用未经时购圈认可的程序或者非正常浏览等技术手段获取内容数据的行为）。</span>
						</p>
						<p>
							<span>（9）<span style="font-weight: bold; color: #007bff">【特定服务与专项规则】</span></span>
						</p>
						<p>
							<span>您知悉并同意，平台就某些特定服务（如“拼玩”活动、城市合伙人招募赛事活动、扫码点餐等）制定了专门的公约或规则。您在使用该等特定服务前，应仔细阅读并同意遵守相应的专项规则。所有关于该特定服务的双方权利义务、责任界定及争议解决，均优先适用该专项规则的规定。专项规则与本协议约定不一致的，以专项规则为准。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【赛事服务专项规则】</span>
						</p>
						<p>
							<span>您作为参赛用户报名赛事时，应另行勾选同意《时购圈平台赛事报名用户公约》；您作为主办方发布赛事时，应另行勾选同意《时购圈平台赛事主办方使用公约》。该等公约构成本协议不可分割的组成部分，自您勾选同意时对您生效。若您未勾选同意相应公约，平台有权拒绝提供赛事报名或赛事发布服务。就赛事服务，赛事专项公约有约定的，优先适用赛事专项公约；赛事专项公约未约定的，适用本协议。平台仅提供赛事技术支持服务，不是赛事主办方或组织方。赛事的实际组织、安全、保险、奖项发放等由主办方负责，具体责任划分以相应赛事专项公约约定为准。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【扫码点餐服务专项规则】</span>
						</p>
						<p>
							<span>您首次使用扫码点餐服务时，平台或合作商户将在身份确认环节以显著方式向您展示个人信息处理规则，并征得您的主动勾选同意后，方进行身份核验。您拒绝同意的，仍可通过纸质菜单或人工点餐完成消费。平台仅提供扫码点餐的技术支持服务，不参与餐饮服务的实际提供。餐品质量、价格、食品安全、就餐服务等由合作商户负责。扫码点餐的个人信息处理规则构成本协议不可分割的组成部分。就扫码点餐服务，专项规则有约定的优先适用；专项规则未约定的，适用本协议及《时购圈隐私政策》。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【使用目的】</span>
							<span>除非在特定服务条款或规则中您与时购圈另有约定或时购圈另行予以书面同意，您将确保本协议下的服务仅为您个人非商业性质的使用。未经时购圈书面同意，您不得使用未经时购圈授权的任何插件、外挂或第三方工具对本协议下的服务进行干扰、破坏、修改或施加其他影响。</span>
						</p>
						<p>
							<span>（10）不应通过技术手段恶意拦截、篡改或伪造平台或第三方推送消息，不得利用推送功能从事骚扰、欺诈等违规行为。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">五、知识产权</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【知识产权】</span>
							<span>您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权（包括但不限于专利权、著作权、商标权及商业秘密）归时购圈所有：</span>
						</p>
						<p>
							<span>1、 在时购圈相关服务中所提供的内容和信息（包括但不限于软件、技术、程序、网页、文字、图片、图像、地图、图标、音频、视频、图表、版面设计、电子文档、数据资料等）；</span>
						</p>
						<p>
							<span>2、时购圈用于提供上述内容和信息的基础设施和平台（包括但不限于软件、网站、应用程序等）；</span>
						</p>
						<p>
							<span>3、在时购圈提供相关服务中所使用的各项商标、商业形象、商业标识、技术诀窍、标语、文案等；</span>
						</p>
						<p>
							<span>4、时购圈平台服务的开发、运营、维护等过程中产生的所有数据和信息。</span>
						</p>
						<p>
							<span>时购圈所拥有的上述权利及所提供服务中所包含的任何内容的知识产权均受到法律保护，未经时购圈事先书面许可，您承诺不应且不应允许或协助任何人以任何形式（包括但不限于通过任何机器人、蜘蛛、截屏等程序或设备）进行使用、出租、出借、分发、展示、复制、修改、链接、转载、汇编、发表、出版、抓取、监视、引用或创造相关衍生作品。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【用户生成内容】</span>
							<span>您理解并同意，您在使用时购圈提供的服务时上传、提交、发布的内容（包括但不限于文字、图片、视频、音频、动画等）均由您原创或已获合法授权。您通过时购圈上传、提交、存储或发布的任何内容的知识产权归属您或原始著作权人所有，您的上传、提交、存储或发布行为不会侵犯他人的知识产权或其他合法权益。</span>
						</p>
						<p>
							<span>您知悉、理解并同意，您在本平台上传、发布内容的行为，即视为您授予时购圈及其关联公司一项全球范围内、免许可费的、非独家的、普通使用许可，许可期限为您内容在本平台存续的整个期间。该许可旨在便于我们为您提供及优化服务，包括但不限于对您的内容进行存储、展示、传播、复制及必要的技术性修改（如格式转换、终端适配）或用于本平台及相关产品的宣传推广。当您删除特定内容或注销账号后，我们将停止基于该许可继续使用您的内容，并在技术上可行的范围内于合理期限内将其从平台服务器中移除。</span>
						</p>
						<p>
							<span>为使平台能有效制止对您上传内容的侵权行为，您不可撤销地授权时购圈及其关联公司，在发现第三方侵犯您在本平台发布的内容的知识产权时，有权以自身名义或委托第三方代表您采取包括但不限于发送警告函、提起诉讼、仲裁、调解、和解等任何维权措施。通过前述方式获得的赔偿款项，在扣除为维权支出的必要成本（如公证费、律师费、诉讼费等）后，归属于您。若您明确表示不同意平台进行前述维权，应及时书面通知平台。</span>
						</p>
						<p>
							<span>您同意，因您通过时购圈上传、发布的任何内容导致的知识产权侵权问题，您将承担全部责任；如时购圈及其关联公司，或时购圈授权的其他服务提供方因第三方知识产权维权而产生损失，您将等额赔偿。</span>
						</p>
						<p>
							<span>本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在时购圈平台发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。时购圈及时购圈转授权、许可的相关方有权将您在时购圈平台发表的产品使用体验、产品讨论或图片进行使用或者与其他人合作使用，使用范围包括但不限于网站、电子杂志、杂志、刊物、海报、公众号文章、微信小程序等。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【软件使用】</span>
							<span>在使用时购圈相关客户端的过程中，您可能需要下载特定软件。为了改善用户体验、修复漏洞、保障安全性等考虑，时购圈有权对软件进行更新，您应该将相关软件更新至最新版本，否则时购圈将不保证您能正常使用相关软件。</span>
						</p>
						<p>
							<span>如果您从未经时购圈授权的第三方获取软件或与该软件名称相同的安装程序，时购圈无法保证该软件能够正常使用，由此造成的相关损失，时购圈不予负责。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【软件使用禁止性规定】</span>
							<span>除非时购圈书面许可，您在使用时购圈的软件时不得从事下列任一行为：</span>
						</p>
						<p>
							<span>（1）删除、编辑或遮挡软件及其副本上关于著作权、商标或其他权利标识或标记的信息；</span>
						</p>
						<p>
							<span>（2）复制、发布、出售、出租软件或其任何部分；</span>
						</p>
						<p>
							<span>（3）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试挖掘、提取软件的源代码；</span>
						</p>
						<p>
							<span>（4）&nbsp;其他对软件、软件所产生的数据所进行的任何增加、删减、变动的任何行为，包含制作、利用、授权各种第三方外挂、插件、系统进行上述行为。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">六、协议的终止</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【协议终止情形】</span>
							<span>本协议于以下任一情形下终止：</span>
						</p>
						<p>
							<span>（1）时购圈有权依据本协议约定，收回、注销用户账号，此情形下，本协议于账号收回、注销之日终止；</span>
						</p>
						<p>
							<span>（2）在满足时购圈平台公示的账号注销条件时，您通过时购圈APP，注销时购圈的用户账号，本协议于账号注销之日终止。您理解并同意，您已认真阅读、认可《时购圈隐私政策》及其附件一《用户注销协议》，并已了解、同意相关用户注销流程及注销后的权利义务安排；</span>
						</p>
						<p>
							<span>（3）时购圈有权根据自身商业安排经过合理的提前通知终止全部时购圈平台服务，本协议于时购圈平台全部服务依法定程序及方式终止之日终止。</span>
						</p>
						<p>
							<span>本协议终止后，时购圈将无法继续向您提供任何服务或履行任何其他义务，包括但不限于为您保留或向您披露其原时购圈账号中的任何信息，向您或第三方转发任何未曾阅读或发送过的信息等。</span>
						</p>
						<p>
							<span>本协议的终止不影响第五条知识产权条款以及其他根据其内容应继续有效的条款的有效性，也不影响本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">七、通知与送达</span></p>
						<p>
							<span>您知悉并认可，时购圈可视情况通过下列任意一种或几种方式向您通知重要信息：</span>
						</p>
						<p>
							<span>（1）向您注册时所提交的电子邮箱地址发送电子信息；</span>
						</p>
						<p>
							<span>（2）向您注册时所提交的手机号码发送电子信息；</span>
						</p>
						<p>
							<span>（3）向您提供的实际地址进行寄送纸质载体信息；</span>
						</p>
						<p>
							<span>（4）在网站或客户端显著位置刊登电子信息；</span>
						</p>
						<p>
							<span>（5）向时购圈网站或相应客户端的账户的站内信或其他即时通信客户端发送电子信息。</span>
						</p>
						<p>
							<span>上述电子信息在发送成功或刊登完成后即视为送达。相关纸质载体的发送以相关邮寄凭证上的邮寄日期后的第七个自然日视为送达。</span>
						</p>
						<p>
							<span>上述送达方式同样可适用于相关仲裁或司法程序（含起诉、审理、执行等各阶段）。</span>
						</p>
						<p>
							<span>您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于时购圈的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">八、不可抗力或其他免责事由</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【不可抗力】</span>
							<span>您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本协议下的服务发生中断或终止。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、法律法规变动、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务等行为。出现上述情况时，时购圈将努力在第一时间与相关部门配合，及时进行修复，但是由此给您造成的损失，时购圈在法律允许的范围内免责。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【其他免责事由】</span>
							<span>您理解并同意，在符合法律规定的情况下，时购圈对以下事由所导致的服务中断或终止不承担责任：</span>
						</p>
						<p>
							<span>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</span>
						</p>
						<p>
							<span>（2）用户或时购圈的电脑软件、系统、硬件和通信线路出现故障；</span>
						</p>
						<p>
							<span>（3）用户操作不当；</span>
						</p>
						<p>
							<span>（4）用户通过非时购圈授权的方式使用本服务；</span>
						</p>
						<p>
							<span>（5）其他时购圈无法控制或合理预见的情形。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【信息真实性】</span>
							<span>时购圈提示您，在使用本服务的过程中，您可能会遇到网络信息或其他用户行为带来的风险，该等风险包含他人匿名或冒名的含有威胁、诽谤、令人反感、非法、误导、欺骗等任何信息或行为所造成任何心理、生理上的伤害或经济损失。请您仔细甄别，并在遇到上述相关不法行为时及时向时购圈或有关机关举报或投诉。时购圈将对相关内容开展日常检查并在收到举报或投诉时进行相应处理。</span>
						</p>
						<p>
							<span>平台依据相关法律法规，对用户在本平台（包括网站、客户端及其他线上形式）上发布、传输的任何信息内容依法负有管理责任。对于在线上场景中发现的、或经他人举报的明显违法违规或侵权信息，平台将根据情况依法采取删除、屏蔽、等必要措施。</span>
						</p>
						<p>
							<span>用户理解并同意，前述管理责任仅限于平台提供的线上网络服务。对于用户通过平台信息引流后在线下实体场所（包括但不限于参与拼玩活动、到店消费等）发生的一切行为、风险、纠纷及损害，平台不承担任何形式的责任，相关责任由用户、活动组织者及服务提供方自行承担。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【责任限制】</span>
							<span>除非另有明确书面说明，在符合法律法规规定的情况下，时购圈不对其网站和客户端上的信息、内容、材料、产品或服务做任何形式的明示或默示的声明或担保</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">九、管辖、法律适用与争议解决</span></p>
						<p>
							<span>本协议的成立、生效、履行、解释及争议解决，均适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
						</p>
						<p>
							<span>因本协议引起的或与本协议有关的任何争议，双方应首先友好协商解决；协商不成的，任何一方均有权将争议提交至时购圈科技有限公司住所地有管辖权的人民法院通过诉讼解决。</span>
						</p>
						
						<p><span style="font-weight: bold; color: #007bff">十、其他</span></p>
						<p>
							<span style="font-weight: bold; color: #007bff">【关键词】</span>
							<span>本协议各条款前所列关键词仅供帮助理解条款主旨及快速定位查询条款所用，不能代替条款的任何内容，亦不作为解释条款的依据，时购圈建议您仔细阅读各条款的具体表述，以维护您的合法权益。</span>
						</p>
						<p>
							<span style="font-weight: bold; color: #007bff">【可分性】</span>
							<span>如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span>
						</p>
						<p>
							<span>如您对本协议有任何问题或建议，请在工作时间联系时购圈线上客服。再次感谢您的耐心阅读！</span>
						</p>

					</div>
				</span>
			</div>
		</div>
		<tabbar></tabbar>
	</div>
</template>

<script>
export default {
	name: 'service',
	props: {
		msg: String
	},
	data() {
		return {
			path: '/service'
		};
	},
	methods: {}
};
</script>

<style>
html,
body {
	width: 100%;
	height: 100%;
	margin: 0;
	overflow: auto;
}

.main-service {
	width: 100%;
	height: 100%;
	padding-top: 100px;
	box-sizing: border-box;
}

.container-service {
	width: 100%;
	min-height: 100%;
	padding: 5% 15% 0 15%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
}

.service-richtext {
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	word-wrap: break-word;
}

.service-richtext-title {
	font-size: 40px;
	font-weight: 900;
}

.service-richtext-content {
	margin-top: 100px;
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: center;
	text-align: left;
	font-size: 16px;
	box-sizing: border-box;
	word-wrap: break-word;
	line-height: 25px;
}

@media screen and (max-width: 768px) {
	.container-service {
		padding: 5%;
	}

	.service-img {
		width: 100%;
	}

	.service-richtext-content {
		margin-top: 50px;
	}
}
</style>
